module.exports = __webpack_public_path__ + "static/img/recommend_img_01.a4071e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recommend_img_01.png
// module id = cB5G
// module chunks = 1